export default {
    sidebar: 'Διασύνδεση AI',
    title: 'Διασύνδεση AI',
    subtitle: 'Διαχειρίσου τα tokens που επιτρέπουν σε AI assistants (Claude, ChatGPT κ.ά.) να συνδέονται στον λογαριασμό σου.',
    oauthBadge: 'OAuth',
    manualBadge: 'Χειροκίνητο',

    manageBanner: 'Κάθε token δίνει σε έναν AI agent συνεχή πρόσβαση στα δεδομένα υγείας των πελατών σου. Ανακάλεσε όσα δεν χρησιμοποιείς ενεργά.',

    create: '+ Νέο token',
    createTitle: 'Δημιουργία νέου token',
    nameLabel: 'Όνομα',
    namePlaceholder: 'π.χ. "Claude Desktop", "ChatGPT στο laptop"',
    scopesLabel: 'Δικαιώματα πρόσβασης',
    createButton: 'Δημιουργία',


    scopeDescriptions: {
        'read': 'Ανάγνωση των δεδομένων του athlisis — πελάτες, μετρήσεις, ερωτηματολόγια, βάση τροφίμων, πρότυπα γεύματα, προφίλ. Περιλαμβάνει δεδομένα υγείας πελατών.',
        'write:plans': 'Δημιουργία και ενημέρωση διατροφικών πλάνων',
    },

    copyWarning: 'Αντιγράψτε το token τώρα — δεν θα εμφανιστεί ξανά. Αν το χάσετε, ανακαλέστε το και δημιουργήστε νέο.',
    tokenLabel: 'Το νέο σας token',
    copy: 'Αντιγραφή',
    copied: 'Αντιγράφηκε!',
    howToUse: 'Πώς να το χρησιμοποιήσετε:',
    done: 'Έγινε',

    connectionGuides: {
        heading: 'Πώς να συνδέσεις τον AI assistant σου',
    },

    empty: 'Δεν έχεις συνδεδεμένους AI agents ακόμα',
    emptyText: 'Πάτα «Νέο token» για να ξεκινήσεις.',
    revoke: 'Ανάκληση',
    revoked: 'Ανακλήθηκε',
    revokeConfirm: 'Θέλεις σίγουρα να ανακαλέσεις το token «{name}»; Θα πάψει να λειτουργεί άμεσα.',
    created: 'Δημιουργήθηκε',

    accessWarning: {
        title: 'Σημαντικό — διαβάστε προτού χορηγήσετε πρόσβαση',
        scope: 'Ο agent αποκτά συνεχή πρόσβαση να διαβάζει (και, εφόσον δώσετε δικαιώματα write, να τροποποιεί ή να διαγράφει) δεδομένα εντός των δικαιωμάτων που χορηγείτε — συμπεριλαμβανομένων μετρήσεων, ερωτηματολογίων και άλλων ευαίσθητων δεδομένων υγείας των πελατών σας.',
        responsibility: 'Ως υπεύθυνος επεξεργασίας οφείλετε να έχετε τη ρητή συγκατάθεση των πελατών σας για κοινοποίηση των δεδομένων υγείας τους στα συστήματα AI που επιλέγετε. Το AI δεν αντικαθιστά την κλινική σας κρίση — αντιμετωπίστε το output του agent ως προτάσεις, όχι ως διάγνωση ή ιατρική συμβουλή.',
        revocation: 'Το athlisis δεν παρακολουθεί τι κάνει ο agent εκ μέρους σας. Μπορείτε να ανακαλέσετε την πρόσβαση όποτε θέλετε, αλλά οι ενέργειες που έχουν ήδη γίνει — συμπεριλαμβανομένων διαγραφών — δεν μπορούν να αναιρεθούν.',
    },

    acknowledgments: {
        heading: 'Παρακαλώ επιβεβαιώστε:',
        consent: 'Έχω ρητή συγκατάθεση από τους πελάτες μου για κοινοποίηση των δεδομένων υγείας τους στα συστήματα AI που εξουσιοδοτώ.',
        responsibility: 'Αναλαμβάνω την κλινική ευθύνη για κάθε απόφαση που λαμβάνω βάσει output από αυτόν τον agent.',
        notMedicalAdvice: 'Κατανοώ ότι το athlisis δεν ευθύνεται για τη χρήση των δεδομένων μου από τον agent ή για τυχόν συμπεράσματα που παράγει.',
    },

    grant: {
        title: 'Εξουσιοδότηση agent',
        loading: 'Φόρτωση…',
        wantsAccess: 'ζητά πρόσβαση στον λογαριασμό σας στο athlisis',
        heading: 'Να επιτραπεί στο {name} η πρόσβαση στον λογαριασμό σας;',
        subtitle: 'Η αποδοχή θα εκδώσει token για αυτόν τον agent. Μπορείτε να το ανακαλέσετε όποτε θέλετε από τις ρυθμίσεις του λογαριασμού.',
        redirectLabel: 'Θα μεταφερθείτε στο:',
        scopesHeader: 'Ζητούμενα δικαιώματα:',
        allow: 'Επιτρέπω',
        deny: 'Άκυρο',
        unknownRequester: 'AI agent',
        errorTitle: 'Δεν ήταν δυνατή η ολοκλήρωση',
        backToDashboard: 'Πίσω στις ρυθμίσεις',
        errors: {
            missingRedirect: 'Δεν δόθηκε URL επιστροφής. Ζητήστε από τον agent έγκυρο σύνδεσμο σύνδεσης.',
            invalidRedirect: 'Το URL επιστροφής δεν είναι έγκυρο.',
            unsafeRedirect: 'Το URL επιστροφής πρέπει να χρησιμοποιεί https (ή http://localhost).',
            noValidScopes: 'Ο agent δεν ζήτησε έγκυρα δικαιώματα.',
            loadFailed: 'Δεν ήταν δυνατή η φόρτωση των δικαιωμάτων. Δοκιμάστε ξανά.',
            grantFailed: 'Η παροχή πρόσβασης απέτυχε. Δοκιμάστε ξανά.',
            missingClient: 'Ο agent δεν προσδιόρισε τον εαυτό του.',
            missingChallenge: 'Ο agent δεν παρείχε PKCE code challenge.',
        },
    },
};
